type ParseType = 'json' | 'none'

type InferredResult<T, P extends ParseType> = P extends 'json' ? T : Response

export const fetchApi = async <Result, P extends ParseType = 'json'>({
  url,
  visitorId,
  userId,
  appId,
  method = 'GET',
  authorization,
  body,
  parse = 'json',
}: {
  url: string
  visitorId: string
  appId: string
  userId?: string
  method?: 'GET' | 'POST'
  authorization?: string
  body?: BodyInit | null
  parse?: ParseType
}): Promise<InferredResult<Result, P>> => {
  const headers: Record<string, string> = {
    'x-app': appId,
    'x-visitor-id': visitorId,
    ...(body && { 'Content-Type': 'application/json' }),
  }

  if (userId) {
    headers['x-user-id'] = userId
  }

  if (authorization) {
    headers['Authorization'] = authorization
  }

  const res = await fetch(`${process.env.RUNTIME_SURVEY_URL}${url}`, {
    method,
    headers,
    body,
  })

  if (parse === 'json') {
    return (await res.json()) as InferredResult<Result, P>
  }

  return res as InferredResult<Result, P>
}
